module.exports = __webpack_public_path__ + "media/packs/images/flags/ZM-605b800ad7d9c79c95197b4c7e9b783c.png";